import { IState } from 'models';
import { GetAllFactory } from './base.service';
import CrudService from './crud.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'states';
const SERVICE_NAME = 'States';

export default new CrudService<IState>(SERVICE_NAME, BASE_URL);

export interface GetAllParams extends BaseGetAllParams {
  idCountry: string;
}

export const GetAll = GetAllFactory<IState, GetAllParams>(BASE_URL);
